import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsIntegration2V4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M64 34V64H34" stroke="#FFDD00" strokeWidth="2" />
      <path d="M0 30H30V0" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
